import React, { useState, useEffect, useMemo } from "react";
import { fetch, fetchLocalAgent } from "../../actions";
import { connect } from "react-redux";
import { ModalPadrao, InputPadrao, LabelPadrao, LoadingContainerPadrao, SemDados, ObsIcon } from "../../components/Base";
import { DrawerPadrao } from "../../components/DialogPadrao";
import { Tag, Divider, Tooltip } from "antd";
import TabelaPadrao from "../../components/TabelaPadrao";
import { useFetch, useSave } from "../../components/Hooks/Conexao";
import toLocale from "../../Utils/ToLocaleString";
import ModalCancelamentoPadrao from "../../components/ModalCancelamentoPadrao";
import { BtnCancelar, BtnGravar, BtnLink, BtnPadrao, BtnSair } from "../../components/Buttons";
import Mensagens from "../../components/Mensagens";
import ModalFinalizarEntrega from "./ModalFinalizarEntrega";
import { formatarPagamentos, returnStatus } from "../../Utils/utils";
import culture from "../../Utils/Culture";
import EntregaEnderecoSelect from "./EntregaEnderecoSelect";
import formatarData from "../../Utils/formatarData";
import InputBlur from "../../components/InputBlur";
import roundCustom from "../../Utils/RoundCustom";
import ModalSinalPreVenda from "../Venda/ModalSinalPreVenda";
import { imprimirRetorno } from "../../Utils/impressaoUtils";
import DanfeViewer from "../Venda/NotaFiscal/DanfeViewer";
import ImpressaoVenda from "../Impressao/ImpressaoVenda";
import ImpressaoVendaOpcional from "../Impressao/ImpressaoVendaOpcional";

function EntregaConsultaDetalhe({ id, onOk, onCancel, ...props }) {
  const [detalhe, listarDetalhe, loadingDetalhe, setDetalhe] = useFetch(() => props.fetch().post(`/entrega/get/${id}`));
  const [sinalDetalhe, setSinalDetalhe] = useState(null);
  const [salvar, salvando] = useSave();
  const [modalVisivel, setModalVisivel] = useState(null);
  const [dadosDanfe, setDadosDanfe] = useState(null);
  const [dadosImpressaoOpcional, setDadosImpressaoOpcional] = useState(null);
  const [idVendaImpressao, setIdVendaImpressao] = useState(null);

  useEffect(() => {
    if (id)
      listarDetalhe();
    else
      setDetalhe(null);

  }, [id]);

  const onSave = txt => {
    Mensagens.showSucesso(txt);
    setModalVisivel(null);
    onOk();
  };

  const cancelar = motivo => salvar(() => props.fetch().post("prevenda/cancelar", { id: detalhe.id, vendaId: detalhe.vendaId, motivo }), () => onSave("Entrega cancelada com sucesso!"));
  const saveDet = (reentregaSolicitada, motivoReentrega) => salvar(() => props.fetch().post("/prevenda/entrega/save", { ...detalhe, reentregaSolicitada, motivoReentrega, pagamentos: formatarPagamentos(detalhe.pagamentos, detalhe.troco) }), ret => {
    if (ret.isDanfe)
      setDadosDanfe(ret);
    else if (!!ret.vendaId)
      setIdVendaImpressao(ret.vendaId);
    else if (!!ret.vendaImpressaoNaoObrigatoriaId)
      setDadosImpressaoOpcional(ret);
    else
      imprimirRetorno(props.fetchLocalAgent, ret);

    onSave("A etapa da entrega avançou com sucesso!");

  });

  const columnsDetPrd = useMemo(() => [
    {
      Header: "Código",
      accessor: "codigo",
      Footer: " ",
    },
    {
      Header: "Descrição",
      accessor: "descricao",
      Cell: props => <div>
        <span>{props.row.original.descricao}</span>
        {!!props.row.original?.obs && <Tooltip placement="bottom" title={props.row.original.obs}>
          <ObsIcon style={{ fontSize: 15, marginLeft: 5 }} />
        </Tooltip>}
      </div>,
    },
    {
      Header: "Quantidade",
      accessor: "qtd",
      tipo: "right",
      Cell: props => <div>
        <span>{culture.format(props.row.original.qtdPaga)}</span>
        {!!props.row.original?.qtdExtra && <Tooltip placement="left" title="Quantidade extra">
          <span style={{ paddingLeft: 5, fontSize: "0.9em" }}>{!!props.row.original.qtdExtra ? ` (${culture.format(props.row.original.qtdExtra)}) ` : ''}</span>
        </Tooltip>}
      </div>,
      SomarQtd: true,
    },
    {
      Header: "Quantidade separada",
      accessor: "qtdSeparada",
      tipo: "right",
      Cell: props => <InputBlur type="number" min={0} max={props.row.original.qtd} value={props.row.original.qtdSeparada} onChange={v => {
        const aux = formatQtdSeparada(detalhe.produtos, v, props.row.original.qtdPaga, props.row.original.id);
        setDetalhe({ ...detalhe, produtos: aux });
      }} />,
      SomarQtd: true,
    },
    {
      Header: "Valor Un.",
      accessor: "valorUn",
      tipo: "rs",
    },
    {
      Header: "Desconto",
      accessor: "descontoExibir",
      tipo: "rs",
      Somar: true,
    },
    {
      Header: "Acréscimo",
      accessor: "acrescimo",
      tipo: "rs",
      Somar: true,
    },
    {
      Header: "Frete",
      accessor: "valorFrete",
      tipo: "rs",
      Somar: true,
    },
    {
      Header: "Total Líquido",
      accessor: "valorTotalExibir",
      tipo: "rs",
      Somar: true,
    },
  ].filter(x => detalhe?.status == "SEP" || x.accessor != "qtdSeparada"), [detalhe]);

  function formatQtdSeparada(itens, qtd, qtdRef, id) {
    const aux = [...itens];
    const inx = aux.findIndex(x => x.id == id);

    if (aux[inx].descontoOriginal == undefined) {
      aux[inx].descontoOriginal = aux[inx].desconto;
      aux[inx].descontoExibirOriginal = aux[inx].descontoExibir;
      aux[inx].acrescimoOriginal = aux[inx].acrescimo;
      aux[inx].valorTotalOriginal = aux[inx].valorTotal;
      aux[inx].valorTotalExibirOriginal = aux[inx].valorTotalExibir;
      aux[inx].valorFreteOriginal = aux[inx].valorFrete;
    }

    aux[inx].qtdSeparada = qtd;

    const isQtdMenor = qtd < qtdRef;

    aux[inx].desconto = isQtdMenor ? roundCustom(aux[inx].descontoRateado * qtd) : aux[inx].descontoOriginal;
    aux[inx].descontoExibir = isQtdMenor ? aux[inx].desconto : aux[inx].descontoExibirOriginal;
    aux[inx].acrescimo = isQtdMenor ? roundCustom(aux[inx].acrescimoRateado * qtd) : aux[inx].acrescimoOriginal;
    aux[inx].valorFrete = isQtdMenor ? roundCustom(aux[inx].valorFreteRateado * qtd) : aux[inx].valorFreteOriginal;
    aux[inx].valorTotal = isQtdMenor ? roundCustom((aux[inx].valorUn * qtd) + aux[inx].acrescimo + aux[inx].valorFrete - aux[inx].desconto) : aux[inx].valorTotalOriginal;
    aux[inx].valorTotalExibir = isQtdMenor ? aux[inx].valorTotal : aux[inx].valorTotalExibirOriginal;

    return aux;
  }

  return <>
    <ModalPadrao
      visible={id}
      title="Entrega Detalhe"
      onCancel={onCancel}
      width={window.innerWidth < 1200 ? window.innerWidth : 1200}
      footer={<div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          {!!detalhe && <div style={{ display: "flex", alignItems: "center" }}>
            {(!detalhe.isPagamentoPendente && (detalhe.status == "PEN" || detalhe.status == "SEP")) && <>
              <Tag
                onClick={() => { if (!salvando) setModalVisivel("etapa"); }}
                color={returnStatus(detalhe.status == "PEN" ? "SEP" : "LIB").color}
                style={{ padding: 5, minWidth: 200, textAlign: "center", fontSize: 13, cursor: "pointer" }}
              >
                {returnStatus(detalhe.status == "PEN" ? "SEP" : "LIB").title}
              </Tag>
            </>}
            {detalhe?.status != "CAN" && <BtnCancelar disabled={salvando} onClick={() => setModalVisivel("can")} />}
            {detalhe?.status == "ROT" && <BtnPadrao disabled={salvando} onClick={() => setModalVisivel("reent")}>Reentrega</BtnPadrao>}
            <BtnLink onClick={() => setModalVisivel("hist")}>Histórico</BtnLink>
          </div>}
        </div>

        <div>
          {(detalhe?.isPagamentoPendente || detalhe?.status === "LIB" || detalhe?.status === "ROT") && <BtnGravar txt={detalhe?.isPagamentoPendente ? "Efetuar pagamento" : (detalhe?.status === "LIB" ? "Confirmar" : "Finalizar")} onClick={() => setModalVisivel("fin")} disabled={salvando} />}
          {(!detalhe?.isPagamentoAntecipado && !detalhe?.isReentrega && (detalhe?.status === "PEN" || detalhe?.status === "SEP" || detalhe?.status === "LIB")) && <BtnPadrao onClick={() => setSinalDetalhe(detalhe.id)}>Adicionar sinal</BtnPadrao>}
          <BtnSair disabled={salvando} onClick={onCancel} />
        </div>
      </div>}
    >
      {detalhe?.isPagamentoAntecipado && <>
        {detalhe?.isPagamentoPendente ? <Tag style={{ width: "100%", marginBottom: 10, padding: 5, textAlign: "center" }} color="warning">Aguardando pagamento</Tag> :
          <Tag style={{ width: "100%", marginBottom: 10, padding: 5, textAlign: "center" }} color="green">Pago antecipado</Tag>}
      </>}

      <LoadingContainerPadrao loading={loadingDetalhe || salvando} style={{ minHeight: 500 }}>
        {!!detalhe &&
          <>
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <div style={{ width: "32.5%" }}>
                <InputPadrao title="Cliente" disabled value={!!detalhe?.clienteId ? detalhe.clienteId[0].label : ""} />
              </div>
              <div style={{ margin: "0 10px", width: "15%" }}>
                <InputPadrao title="Número" disabled value={detalhe.numero} />
              </div>
              <div style={{ width: "32.5%", marginRight: 10 }}>
                <InputPadrao title="Vendedor" disabled value={!!detalhe?.vendedorId ? detalhe.vendedorId[0].label : ""} />
              </div>
              <div style={{ width: "20%" }} >
                <LabelPadrao noMargin>Status</LabelPadrao>
                <Tag style={{ padding: 5, width: "100%", textAlign: "center", fontSize: 13 }} color={returnStatus(detalhe.status).color}>{returnStatus(detalhe.status).title}</Tag>
              </div>
            </div>
            <div style={{ marginTop: 10 }}>
              <InputPadrao title="Endereço" value={!!detalhe?.endereco && `${detalhe.endereco?.logradouro} - ${detalhe.endereco?.numero}`} disabled />
            </div>

            {!!detalhe.produtos.length && <>
              <Divider orientation="left">Produtos</Divider>
              <TabelaPadrao columns={columnsDetPrd} data={detalhe.produtos} style={{ marginTop: 25 }} />
            </>}

            {!!detalhe.servicos.length && <>
              <Divider orientation="left">Serviços</Divider>
              <TabelaPadrao columns={columnsDetServ} data={detalhe.servicos} style={{ marginTop: 25 }} />
            </>}

            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <div style={{ width: "33%" }}>
                <InputPadrao title="Origem Pedido" disabled value={detalhe.empresaOrigem} />
              </div>
              <div style={{ margin: "0 10px", width: "33%" }}>
                <InputPadrao title="Empresa do recebimento" disabled value={detalhe.empresaRecebimento} />
              </div>
              <div style={{ width: "33%" }}>
                <InputPadrao disabled title="Empresa da entrega" value={detalhe.empresaEntrega} />
              </div>
            </div>

            <Divider orientation="left">Pagamentos</Divider>
            <TabelaPadrao columns={columnsDetPgto} data={detalhe.pagamentos} />
          </>}

        {!!detalhe?.reentregasHist?.length && <>
          <Divider orientation="left">Reentregas</Divider>
          {detalhe.reentregasHist.map((i, inxi) => <p key={`info__${inxi}`} style={{ textAlign: "left", paddingLeft: 50, fontWeight: 'bold', fontStyle: 'italic' }} colSpan={3}>{formatarData(i.data).DATAHORASEGUNDOS}{!!i.motivo ? ` - ${i.motivo}` : ""}</p>)}
        </>}
      </LoadingContainerPadrao>

      <DrawerHistorico id={detalhe?.entregaId} visible={modalVisivel == 'hist'} onCancel={() => setModalVisivel(null)} fetch={props.fetch} />
    </ModalPadrao>

    <ModalFinalizarEntrega entrega={detalhe} visible={modalVisivel == "fin"} onCancel={() => setModalVisivel(null)} onSave={() => onSave("Entrega finalizada com sucesso!")} />

    <ModalCancelamentoPadrao title={modalVisivel == "reent" ? "Motivo reentrega" : "Motivo cancelamento da entrega"}
      visible={modalVisivel == "can" || modalVisivel == "reent"}
      onOk={motivo => modalVisivel == "reent" ? saveDet(true, motivo) : cancelar(motivo)}
      onCancel={() => setModalVisivel(null)}
      loading={salvando}
    >
      {modalVisivel == "reent" && <>
        <LabelPadrao>Endereço</LabelPadrao>
        <EntregaEnderecoSelect value={detalhe?.pessoaEnderecosId} onChange={v => setDetalhe({ ...detalhe, pessoaEnderecosId: v.id, endereco: v })} clienteId={(detalhe?.clienteId || [])[0]?.id} />
      </>}
    </ModalCancelamentoPadrao>

    <ModalSinalPreVenda id={sinalDetalhe} onCancel={() => setSinalDetalhe(null)} onOk={() => { setSinalDetalhe(null); onCancel(); }} />

    <DanfeViewer visible={!!dadosDanfe} empresaPk={dadosDanfe?.empresaPk} chave={dadosDanfe?.chaveNfe} onCancel={() => setDadosDanfe(null)} />
    <ImpressaoVenda id={idVendaImpressao} onCancel={() => setIdVendaImpressao(null)} />
    <ImpressaoVendaOpcional id={dadosImpressaoOpcional?.vendaImpressaoNaoObrigatoriaId} vias={dadosImpressaoOpcional?.vias} onOk={() => setDadosImpressaoOpcional(null)} onCancel={() => setDadosImpressaoOpcional(null)} />

    <ModalEtapa status={detalhe?.status} visible={modalVisivel == "etapa"} salvar={() => saveDet(false)} onCancel={() => setModalVisivel(null)} />
  </>;
}

function ModalEtapa({ visible, salvar, onCancel, status }) {
  return <ModalPadrao visible={visible} width={650} onCancel={onCancel} footer={<>
    <BtnGravar txt="Sim" onClick={() => { salvar(); onCancel(); }} />
    <BtnSair onClick={onCancel} />
  </>}>
    <div style={{ textAlign: "center", padding: 5, marginTop: 10 }}>
      <h2>{`Confirmar etapa para ${status == "PEN" ? "separação de marcadoria?" : "liberar a mercadoria para entrega?"}`}</h2>
    </div>
  </ModalPadrao>;
}

function DrawerHistorico({ id, visible, onCancel, fetch }) {
  const [historico, listar, loading] = useFetch(() => fetch().post(`/entrega/gethist/${id}`));

  useEffect(() => {
    if (id && visible)
      listar();
  }, [id, visible]);

  return <DrawerPadrao width={700} title="Historico" placement="right" onCancel={onCancel} visible={visible}>
    <LoadingContainerPadrao loading={loading}>
      <TabelaHistorico historico={historico} />
    </LoadingContainerPadrao>
  </DrawerPadrao>;
}

export default connect(null, { fetch, fetchLocalAgent })(EntregaConsultaDetalhe);

function TabelaHistorico({ historico }) {
  return <>
    {!!historico?.length ? <table className="tabela-padrao">
      <thead>
        <tr>
          <th style={{ textAlign: "left" }}>Data</th>
          <th style={{ textAlign: "left" }}>Usuário</th>
          <th style={{ textAlign: "left" }}>Status</th>
        </tr>
      </thead>
      <tbody>
        {historico.map((x, inx) => <>
          <tr key={inx}>
            <td tyle={{ textAlign: "left" }}>{formatarData(x.data).DATAHORASEGUNDOS}</td>
            <td tyle={{ textAlign: "left" }}>{x.usuario}</td>
            <td tyle={{ textAlign: "left" }}>{x.operacao}</td>
          </tr>

          {x.info?.filter(x => !!x)?.map((i, inxi) => <tr key={`info_${inx}_${inxi}`}>
            <td style={{ textAlign: "left", paddingLeft: 50, fontWeight: 'bold', fontStyle: 'italic' }} colSpan={3}>{i}</td>
          </tr>)}
        </>)}
      </tbody>
    </table> : <>{historico != null && <SemDados />}</>}
  </>;
}

const columnsDetPgto = [
  {
    Header: "Modalidade",
    accessor: "nome",
    Footer: " ",
  },
  {
    Header: "Troco",
    accessor: "troco",
    Cell: props => (props.row.original.tipo == "troco" && !!props.row.original.troco && props.row.original.troco != 0) ? <span >{props.row.original.troco && toLocale(props.row.original.troco)} <span style={{ opacity: 0.5, marginLeft: 10 }}>({toLocale(props.row.original.recebido)})</span></span> : <></>,
  },
  {
    Header: "Valor total",
    accessor: "valor",
    tipo: "rs",
    Somar: true,
  },
];

const columnsDetServ = [
  {
    Header: "Código",
    accessor: "codigo",
    Footer: " ",
  },
  {
    Header: "Descrição",
    accessor: "descricao",
    Cell: props => <div>
      <span>{props.row.original.descricao}</span>
      {!!props.row.original?.obs && <Tooltip placement="bottom" title={props.row.original.obs}>
        <ObsIcon style={{ fontSize: 15, marginLeft: 5 }} />
      </Tooltip>}
    </div>,
  },
  {
    Header: "Prestador",
    accessor: "prestador",
  },
  {
    Header: "Status",
    accessor: "statusServico",
  },
  {
    Header: "Quantidade",
    accessor: "qtd",
    tipo: "dec",
    SomarQtd: true,
  },
  {
    Header: "Valor Un.",
    accessor: "valorUn",
    tipo: "rs",
  },
  {
    Header: "Desconto",
    accessor: "descontoExibir",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Acréscimo",
    accessor: "acrescimo",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Total Líquido",
    accessor: "valorTotalExibir",
    tipo: "rs",
    Somar: true,
  },
];